import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const QuerySegment = styled.div`
  flex: 1;
`;

export const RowHeading = styled.div`
  border: 1px solid ${colors.secondary.lightGray3};
  border-bottom: none;
  padding: 5px 10px;
  background-color: ${colors.secondary.lightGray1};
`;

export const Editor = styled.div`
  background-color: ${colors.primary.white};
  overflow: hidden;
  min-height: 38px;
  display: grid;
  .ace_content {
    font-family: var(--font-family-mono);
  }
  .ace-textmate,
  .ace-xcode {
  }
  .ace_comment {
    color: ${colors.secondary.lightGray3};
  }
`;
